import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EditPlatformSection, PlatformSection } from './platform-section.interface';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlatformSectionService {
  private token!: string;
  private httpOptions: any;

  private basePath = environment.interop.basePath;
  private getPlatformSectionsDTURL = this.basePath + environment.interop.urbanism.nomenclatoare.platformSection.getPlatformSectionsDT;
  private getPlatformSectionsURL = this.basePath + environment.interop.urbanism.nomenclatoare.platformSection.getPlatformSections;
  private getPlatformSectionURL = this.basePath + environment.interop.urbanism.nomenclatoare.platformSection.getPlatformSection;
  private getPlatformSectionActiveURL = this.basePath + environment.interop.urbanism.nomenclatoare.platformSection.getPlatformSectionsActive;

  private updatePlatformSectionURL = this.basePath + environment.interop.urbanism.nomenclatoare.platformSection.putPlatformSection;
  private storePlatformSectionURL = this.basePath + environment.interop.urbanism.nomenclatoare.platformSection.storePlatformSection;
  private updateStatusPlatformSectionActiveURL = this.basePath + environment.interop.urbanism.nomenclatoare.platformSection.changeStatusPlatformSectionActive;

  private deletePlatformSectionURL = this.basePath + environment.interop.urbanism.nomenclatoare.platformSection.deletePlatformSection;

  constructor(private http: HttpClient) {}

  getPlatformSectionDT() {
    return this.http.get(this.getPlatformSectionsDTURL, this.httpOptions);
  }

  getPlatformSection() {
    return this.http.get(this.getPlatformSectionURL);
  }

  getPlatformSections(): Observable<EditPlatformSection[]> {
    return this.http.get(this.getPlatformSectionsURL, this.httpOptions).pipe(map((res: any) => res.data));
  }

  addPlatformSection(platformSection: PlatformSection) {
    return this.http.post(this.storePlatformSectionURL, platformSection, this.httpOptions);
  }

  updatePlatformSection(platformSection: EditPlatformSection) {
    return this.http.post(this.updatePlatformSectionURL, platformSection, this.httpOptions);
  }

  deletePlatformSection(platformSectionId: number) {
    return this.http.delete(this.deletePlatformSectionURL + platformSectionId);
  }

  getActivePlatformSection() {
    return this.http.get(this.getPlatformSectionActiveURL, this.httpOptions);
  }

  updateStatusPlatformSectionActive(platformSection: any) {
    return this.http.post(this.updateStatusPlatformSectionActiveURL, platformSection, this.httpOptions);
  }

  setToken(token: string) {
    this.token = token;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${this.token}`,
      }),
    };
  }
}
